﻿const buttons = document.querySelectorAll('[data-fabric]');

document.addEventListener('DOMContentLoaded', function (event) {
  buttons.forEach((button, index, parent) => {
	let options = JSON.parse(button.dataset.fabric);
	let source = document.querySelector(options.sourceSelector);

	button.addEventListener('click', function (e) {
	  let fabricModelId = source.value;
	  if (!fabricModelId)
		return;

	  let url = `/api/utils/getFabricModel/?fabricModelId=${fabricModelId}`

	  fetch(url, {
		method: 'GET',
		headers: { 'Content-Type': 'application/json' },
	  }).then(response => response.json())
		.then(data => {
		  for (let prop in data) {
			let input = document.querySelector(`[name$="${prop}" i]`);
			if (!input || input.readOnly || input.classList.contains('readonly'))
			  continue;

			switch (input.tagName) {
			  case 'SELECT':
				input.slim.setSelected(`${data[prop]}`);
				break;
			  case 'INPUT':
				switch (input.type) {
				  case 'checkbox':
					switch (typeof data[prop]) {
					  case 'boolean':
						if (data[prop])
						  input.checked = 'checked';
						else
						  input.checked = '';
						break;
					  case 'object':
						let values = Object.values(data[prop]);
						let checkboxes = document.querySelectorAll(`[name$="${prop}" i]`);
						checkboxes.forEach(checkbox => {
						  checkbox.checked = values.includes(checkbox.value);
						});
						break;
					};
					break;
				  case 'date':
					if (!data[prop])
					  continue;
					let date = data[prop].split('T')[0];
					input.value = date;
					break;
				  default:
					input.value = data[prop];
					break;
				}
				break;
			  case 'TEXTAREA':
				input.value = data[prop];
				break;
			}
		  }
		})
		.then(x => {
		  let titleInput = document.querySelector(`[name$="title" i]`);
		  if (!titleInput)
			return;
		  const evt = new Event('keyup', { bubbles: true, cancelable: false });
		  titleInput.dispatchEvent(evt);
		})
		.catch((errors) => { console.error(errors); });

	});
  });
});
